import React, { createContext, useContext, useEffect, useState } from "react";
import { Outlet, Route } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "./index.css";

import { createBrowserRouter, Navigate, RouterProvider, useLocation, useNavigate } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Reset from "./pages/Reset";
import Login from "./pages/Login";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ThemeProvider } from "@emotion/react";
import { createTheme, CssBaseline } from "@mui/material";
import { server } from "./server/mirage";
import LoginLayout from "./components/login/Layout";
import { App } from "./pages/App";
import useRequests from "./hooks/http";

export const ProtectedRoute = ({ children }: any) => {
  // const { user } = useAuth();
  const user = null!;
  if (!user) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }
  return children;
};

const PrivateRoute = ({ isAllowed, redirectPath = "/ ", children }: any) => {
  const { get } = useRequests();

  useEffect(() => {
    get("/userinfo")
      .then((resp: any) => {
        console.log(resp);
        isAllowed = resp.status === 200;
      })
      .catch((resp: any) => {
        isAllowed = false;
      });
  }, []);

  if (!isAllowed) {
    return children ? children : <Outlet />;
  }

  return <Navigate to={redirectPath} replace />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginLayout />,
    children: [
      {
        path: "",
        element: <Login />,
      },
      {
        path: "/reset",
        element: <Reset />,
      },
    ],
  },
  {
    path: "/app",
    element: <PrivateRoute redirectPath="/" />,
    children: [
      {
        path: "",
        element: <App />,
      },
    ],
  },
]);

// server();

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {},
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <RouterProvider router={router}></RouterProvider>
      </ThemeProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
